import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ReportService } from '../report.service';
import { ReportTimeTrackClientDto } from './time-track-client.interface';
import notify from 'devextreme/ui/notify';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { HelpVideoModalComponent } from '../../../../shared/components/help-video-modal/help-video-modal.component';
import { TaskMovementsComponent } from '../../../tasks-page/tasks/task-movements/task-movements.component';

let self: any;

@Component({
  selector: 'app-time-track-client-report',
  templateUrl: './time-track-client-report.component.html',
  styleUrls: ['./time-track-client-report.component.css']
})
export class ReportTimeTrackClientComponent implements OnInit {
  timeTracks: ReportTimeTrackClientDto[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  selectedDayStart!: string;
  selectedDayEnd!: string;
  filter!: any;
  filterAllData: any = {
    sort: '',
    skip: 0,
    limit: 20,
    filters: {}
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions:any = {};
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  curr!: string;
  categories: ICategory[] = [];
  categoriesFilter!: [];
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;
  maxDate!: string;

  constructor(
    public _ReportService: ReportService,
    public _WorkersService: WorkersService,
    public _ClientsService: ClientsService,
    private _broadcaster: Broadcaster,
    private _UtilsService: UtilsService,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _CategoriesService: CategoriesService,
    private sanitizer: DomSanitizer
  ) {
    self = this;
    this.registerStringBroadcast();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/3injkoTdnjg?si=e-kXRvfpSKn3DHGi");
  }


  ngOnInit() {

    this.selectedDayStart = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString()).substring(0, 10);
    this.selectedDayEnd = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()).substring(0, 10);
    this.filter = {
      sort: '',
      skip: 0,
      limit: 20,
      filters: {
        dateStart: this._UtilsService.date.toUTC(this.selectedDayStart + 'T00:00:00.000Z'),
        dateEnd: this._UtilsService.date.toUTC(this.selectedDayEnd + 'T23:59:59.999Z')
      }
    };

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    this.maxDate = `${yyyy}-${mm}-${dd}`;

    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this._ReportService.getTimeTrackByClient(this.filter).subscribe((timeTracks: ReportTimeTrackClientDto[]) => {
      this.totalMoreMinTutorial = timeTracks.length <= 3;
      this._CategoriesService.getCategories({
        filters: { isDeleted: false },
        company: this._AuthService.companyId(),
        sort: 'name',
        skip: 0,
        limit: 1000
      }).subscribe((categories: any) => {
        this.categories = categories;
        this.getTimeTracks(true);
      });
    });
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTimeTracks(true);
      }
    }, 1000);
  }

  selectedDayChange() {
    this.filter.filters.dateStart = this._UtilsService.date.toUTC(this.selectedDayStart + 'T00:00:00.000Z');
    this.filter.filters.dateEnd = this._UtilsService.date.toUTC(this.selectedDayEnd + 'T23:59:59.999Z');
    // this.filter.filters.selectedDayToday = this._UtilsService.date.toUTC(this.selectedDayToday + 'T23:59:59.999Z');
    this.getTimeTracks(true);
  }

  getTimeTracks(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.timeTracks = [];
      this.clearSelection();
    }
    this._ReportService.getTimeTrackByClient(this.filter).subscribe((timeTracks: ReportTimeTrackClientDto[]) => {
      this.timeTracks = _.concat(this.timeTracks, timeTracks);
      this.thereAreMore = timeTracks.length >= this.filter.limit;
      this.loading = false;
      this.ref.detectChanges();
    })
  }

  onChangeCategories() {
    this.filter.filters.categories = this.categoriesFilter;
    notify(`Cargando...` + '', "info", 800);
    setTimeout(() => {
      this.getTimeTracks(true);
    }, 500)
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTimeTracks(true);
    });
  }

  loadMore() {
    /*if (this.thereAreMore && !this.loading) {
      this.filter.skip += this.filter.limit;
      this.getTimeTracks();
    }*/
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        //this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortTimeTracks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getTimeTracks(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTimeTracks(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }

  toggleSelection(_id?: string) {
    if (_id) {
      this.selection.all = false;
      this.selection[_id] = !this.selection[_id];
    } else {
      this.selection = { all: !this.selection.all }
    }
  }

  exportReport() {
    this._ReportService.exportgetTimeTrackByClient(_.cloneDeep(this.filter));
  }

  details(_id: any) {
    this._ClientsService.getClient(_id).subscribe((client) => {
      let config = new MatDialogConfig();
      config.width = '1700px';
      config.maxWidth = '90vw';
      config.viewContainerRef = this._viewContainerRef;
      self.movementsDialogRef = this._dialog.open(TaskMovementsComponent, config);
      self.movementsDialogRef.componentInstance.client = client;

      self.movementsDialogRef.afterClosed().subscribe((result: any) => {
        self.movementsDialogRef = null;
      });
    })
  }

}